/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { EtatStockDto } from '../models/etat-stock-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des états de stock
 */
@Injectable({
  providedIn: 'root',
})
export class EtatsStockService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation etatStockGetList
   */
  static readonly EtatStockGetListPath = '/api/etats-stock/list';

  /**
   * Renvoie la liste des états de stock.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etatStockGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  etatStockGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<EtatStockDto>>> {

    const rb = new RequestBuilder(this.rootUrl, EtatsStockService.EtatStockGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EtatStockDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des états de stock.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etatStockGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  etatStockGetList(params?: {
  }): Observable<Array<EtatStockDto>> {

    return this.etatStockGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<EtatStockDto>>) => r.body as Array<EtatStockDto>)
    );
  }

  /**
   * Path part for operation etatStockLoadList
   */
  static readonly EtatStockLoadListPath = '/api/etats-stock/load-list';

  /**
   * Renvoie la liste des états de stock (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etatStockLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etatStockLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, EtatsStockService.EtatStockLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des états de stock (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etatStockLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etatStockLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.etatStockLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation etatStockGet
   */
  static readonly EtatStockGetPath = '/api/etats-stock/{id}';

  /**
   * Renvoie l'état de stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etatStockGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  etatStockGet$Response(params: {

    /**
     * Identifiant de l&#x27;état de stock
     */
    id: number;
  }): Observable<StrictHttpResponse<EtatStockDto>> {

    const rb = new RequestBuilder(this.rootUrl, EtatsStockService.EtatStockGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EtatStockDto>;
      })
    );
  }

  /**
   * Renvoie l'état de stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etatStockGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  etatStockGet(params: {

    /**
     * Identifiant de l&#x27;état de stock
     */
    id: number;
  }): Observable<EtatStockDto> {

    return this.etatStockGet$Response(params).pipe(
      map((r: StrictHttpResponse<EtatStockDto>) => r.body as EtatStockDto)
    );
  }

  /**
   * Path part for operation etatStockPut
   */
  static readonly EtatStockPutPath = '/api/etats-stock/{id}';

  /**
   * Met à jour l'état de stock en stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etatStockPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etatStockPut$Response(params: {

    /**
     * Identifiant de l&#x27;état de stock à mettre à jour
     */
    id: number;

    /**
     * L'état de stock
     */
    body: EtatStockDto
  }): Observable<StrictHttpResponse<EtatStockDto>> {

    const rb = new RequestBuilder(this.rootUrl, EtatsStockService.EtatStockPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EtatStockDto>;
      })
    );
  }

  /**
   * Met à jour l'état de stock en stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etatStockPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etatStockPut(params: {

    /**
     * Identifiant de l&#x27;état de stock à mettre à jour
     */
    id: number;

    /**
     * L'état de stock
     */
    body: EtatStockDto
  }): Observable<EtatStockDto> {

    return this.etatStockPut$Response(params).pipe(
      map((r: StrictHttpResponse<EtatStockDto>) => r.body as EtatStockDto)
    );
  }

  /**
   * Path part for operation etatStockDelete
   */
  static readonly EtatStockDeletePath = '/api/etats-stock/{id}';

  /**
   * Supprime l'état de stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etatStockDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  etatStockDelete$Response(params: {

    /**
     * Identifiant de l&#x27;état de stock à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, EtatsStockService.EtatStockDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'état de stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etatStockDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  etatStockDelete(params: {

    /**
     * Identifiant de l&#x27;état de stock à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.etatStockDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation etatStockPost
   */
  static readonly EtatStockPostPath = '/api/etats-stock';

  /**
   * Crée l'état de stock spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etatStockPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etatStockPost$Response(params: {

    /**
     * L'état de stock
     */
    body: EtatStockDto
  }): Observable<StrictHttpResponse<EtatStockDto>> {

    const rb = new RequestBuilder(this.rootUrl, EtatsStockService.EtatStockPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EtatStockDto>;
      })
    );
  }

  /**
   * Crée l'état de stock spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etatStockPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etatStockPost(params: {

    /**
     * L'état de stock
     */
    body: EtatStockDto
  }): Observable<EtatStockDto> {

    return this.etatStockPost$Response(params).pipe(
      map((r: StrictHttpResponse<EtatStockDto>) => r.body as EtatStockDto)
    );
  }

  /**
   * Path part for operation etatStockPostMultiple
   */
  static readonly EtatStockPostMultiplePath = '/api/etats-stock/Multiple';

  /**
   * Crée les états de stock spécifiés.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `etatStockPostMultiple()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etatStockPostMultiple$Response(params: {

    /**
     * Liste des états de stock
     */
    body: Array<EtatStockDto>
  }): Observable<StrictHttpResponse<Array<EtatStockDto>>> {

    const rb = new RequestBuilder(this.rootUrl, EtatsStockService.EtatStockPostMultiplePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<EtatStockDto>>;
      })
    );
  }

  /**
   * Crée les états de stock spécifiés.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `etatStockPostMultiple$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  etatStockPostMultiple(params: {

    /**
     * Liste des états de stock
     */
    body: Array<EtatStockDto>
  }): Observable<Array<EtatStockDto>> {

    return this.etatStockPostMultiple$Response(params).pipe(
      map((r: StrictHttpResponse<Array<EtatStockDto>>) => r.body as Array<EtatStockDto>)
    );
  }

}
